// Hooks
import { useApp } from 'Shared/utils/hooks/use-app';

export const useMarketingUrl = () => {
  const { app } = useApp();
  const SOURCE_QUERY_PARAM = '?source=software-perform';

  const PIMarketingUrl = `${app.piMarketingPageUrl}${SOURCE_QUERY_PARAM}`;

  const PIPerformMarketingUrl = `${app.performMarketingPageUrl}${SOURCE_QUERY_PARAM}`;

  const PISoftwareMarketingUrl = `${app.piMarketingPageUrl}/software${SOURCE_QUERY_PARAM}`;

  return { PIMarketingUrl, PIPerformMarketingUrl, PISoftwareMarketingUrl };
};
